import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import apiInstanceV2 from "../../Apis/AxiosV2";
const serviceName = "foodie-menu-service";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const GetCafeteriaById = createAsyncThunk('cafeterias/getCafeteriaById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/cafeterias/by-id/${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateCafeteria = createAsyncThunk("cafeterias/createCafeteria",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/cafeterias/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateCafeteria = createAsyncThunk("cafeterias/updateCafeteria",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(`${serviceName}/v1/cafeterias/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetAvailableDevicesByModeIds = createAsyncThunk('cafeterias/getAvailableDevicesByModeIds', async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .post(`${serviceName}/v1/cafeterias/devices/available`, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetDepartmentsByCafeteriaId = createAsyncThunk('cafeterias/getDepartmentsByCafeteriaId', async (id, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(`${serviceName}/v1/cafeterias/${id}/departments/download`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});


export const GetUsersByCafeteriaId = createAsyncThunk('cafeterias/getUsersByCafeteriaId', async (id, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(`${serviceName}/v1/cafeterias/${id}/users/download`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
